import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useAppServices } from 'hook/services'

const KnowledgeBaseContext = createContext(null)

const defaultKB = {
  dashboard: '',
  business: '',
  submission: '',
  consumer: '',
  branding: '',
  plans: '',
  settings: '',
  leads: '',
}

export const KnowledgeBaseProvider = ({ children }) => {
  const Service = useAppServices()

  const [knowledgeBase, setKnowledgeBase] = useState(defaultKB)
  const [loading, setLoading] = useState(false)

  const fetchKnowledgeBase = async () => {
    try {
      setLoading(true)
      const { response } = await Service.superadmin.GET()

      if (response?.success) {
        const kb = response?.data?.knowledge_base || {}

        setKnowledgeBase({
          ...defaultKB,
          ...kb,
        })
      }
    } catch (error) {
      console.error('Failed to fetch knowledge base', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchKnowledgeBase()
  }, [])

  return (
    <KnowledgeBaseContext.Provider
      value={{
        knowledgeBase,
        loading,
        refreshKnowledgeBase: fetchKnowledgeBase,
      }}
    >
      {children}
    </KnowledgeBaseContext.Provider>
  )
}

export const useKnowledgeBase = () => {
  const context = useContext(KnowledgeBaseContext)
  if (!context) {
    throw new Error(
      'useKnowledgeBase must be used within KnowledgeBaseProvider'
    )
  }
  return context
}
